import * as Sentry from "@sentry/react";

type AdminUiLogLevel = "debug" | "info" | "warn" | "error";

type AdminUiEventName =
	| "auth.logout"
	| "location.access"
	| "location.switch"
	| "shop.access"
	| "shop.switch";

interface AdminUiEventLog {
	name: AdminUiEventName;
	message: string;
	level?: AdminUiLogLevel;
	attributes?: Record<string, unknown>;
}

interface SentryAuthUser {
	id: string;
	email?: string;
}

const sentryLoggers = {
	debug: Sentry.logger.debug,
	info: Sentry.logger.info,
	warn: Sentry.logger.warn,
	error: Sentry.logger.error,
} as const;

export const logAdminUiEvent = ({
	name,
	message,
	level = "info",
	attributes = {},
}: AdminUiEventLog) => {
	sentryLoggers[level](message, {
		app_surface: "adminui",
		event_name: name,
		source: "frontend",
		...attributes,
	});
};

export const syncSentryUser = (user: SentryAuthUser | null) => {
	Sentry.setUser(
		user
			? {
				id: user.id,
				email: user.email,
			}
			: null
	);
};
